var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6719 10.9719L19.7469 4.95313C20.0844 4.61563 20.0844 3.99688 19.7469 3.65938L18.3406 2.25313C18.0031 1.91562 17.3844 1.91562 17.0469 2.25313L11.0281 8.32813L4.95313 2.25313C4.61563 1.91562 3.99688 1.91562 3.65938 2.25313L2.25313 3.65938C1.91562 3.99688 1.91562 4.61563 2.25313 4.95313L8.32813 10.9719L2.25313 17.0469C1.91562 17.3844 1.91562 18.0031 2.25313 18.3406L3.65938 19.7469C3.99688 20.0844 4.61563 20.0844 4.95313 19.7469L11.0281 13.6719L17.0469 19.7469C17.3844 20.0844 18.0031 20.0844 18.3406 19.7469L19.7469 18.3406C20.0844 18.0031 20.0844 17.3844 19.7469 17.0469L13.6719 10.9719Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a35da5755d02e0166dd80472dd4a7542.svg";
export { ForwardRef as ReactComponent };